export default __webpack_public_path__ + "static/women-using-app-4414f6f0d2d24fb2e5b3de0afda4f22c.png";